import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-checked",
  "use": "icon-icon-checked-usage",
  "viewBox": "0 0 11 8.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 8.2\" id=\"icon-icon-checked\"><title>资源 1</title><g id=\"icon-icon-checked_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-checked_OBJECTS\"><rect x=\"1.8\" y=\"2.2\" width=\"2.3\" height=\"6.17\" transform=\"translate(-2.8 3.7) rotate(-45)\" /><rect x=\"6\" y=\"-0.5\" width=\"2.3\" height=\"8.76\" transform=\"translate(4.8 -3.9) rotate(45)\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-checked.svg
// module id = zTO7
// module chunks = 72